import React, { Component } from "react";
import Modal from "react-responsive-modal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Loader, Button } from "@revvsales/components";

import InviteSection from "./InviteSection";
import AccessListing from "./AccessListing";
import { fetchOppoAccessService } from "../../../actions/PipelineActions/pipelineServices";

class OppoSharingPopup extends Component {
  state = { isLoading: false, sharedList: [] };

  componentDidMount() {
    this._fetchOppoAccess(this.props.oppo.id);
  }

  _fetchOppoAccess = oppoID => {
    fetchOppoAccessService(oppoID).then(res => {
      this.setState({ sharedList: res.Users || [] });
    });
  };

  render() {
    const { oppo } = this.props;
    const popupHeaderSpace = (
      <div className="oppo-sharing-info-box">
        <div className="account-details-container">
          <span className="account-details-metatitle">
            <i>
              <FontAwesomeIcon icon={["far", "crown"]} />
            </i>
            Opportunity
          </span>
          <span className="pipeline-opportunity">{oppo.name}</span>
        </div>
        <div className="account-details-container">
          <span className="account-details-metatitle">
            <i>
              <FontAwesomeIcon icon={["far", "briefcase"]} />
            </i>
            Account
          </span>
          <span className="pipeline-acc">{oppo.crm_account.name}</span>
        </div>
      </div>
    );
    const errSpace = null;
    return (
      <Modal
        open
        onClose={this.props.closePopup}
        closeOnOverlayClick={false}
        center>
        {this.state.isLoading && (
          <Loader
            className="saving-document"
            label="Please wait while we create the document !"
            fullScreen
          />
        )}
        <div className="opposharepopup">
          <div className="row">
            <div className="col-md-12">
              <div className="createdoc-title">Share Settings</div>
              <div className="popup-form">
                {popupHeaderSpace}
                {errSpace}
                <InviteSection
                  list={this.state.sharedList}
                  oppo={this.props.oppo}
                  fetchOppoAccess={this._fetchOppoAccess}
                />
                <AccessListing
                  list={this.state.sharedList}
                  oppo={this.props.oppo}
                  fetchOppoAccess={this._fetchOppoAccess}
                />
              </div>
            </div>
          </div>
          <div className="createquotepopup-footer popup-footer">
            <div className="footer-actions">
              <Button
                className="btn btn-primary"
                onClick={() => this.props.closePopup()}
                data-test="opposharingpopup-done-btn">
                DONE
              </Button>
            </div>
          </div>
        </div>
      </Modal>
    );
  }
}

export default OppoSharingPopup;



// WEBPACK FOOTER //
// ./src/components/PipelineWrapper/OppoSharingPopup/OppoSharingPopup.js